import React from "react";

const ArrowUpIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_219_27273)">
        <path
          d="M7.05018 4.6365C6.49789 4.6365 6.05018 5.08421 6.05018 5.6365C6.05018 6.18878 6.49789 6.6365 7.05018 6.6365L15.9497 6.6365L4.92886 17.6573C4.53833 18.0478 4.53833 18.681 4.92886 19.0715C5.31938 19.462 5.95254 19.462 6.34307 19.0715L17.3639 8.05071L17.3639 16.9502C17.3639 17.5025 17.8116 17.9502 18.3639 17.9502C18.9162 17.9502 19.3639 17.5025 19.3639 16.9502L19.3639 5.6365C19.3639 5.08421 18.9162 4.6365 18.3639 4.6365L7.05018 4.6365Z"
          fill="#646F87"
        />
      </g>
      <defs>
        <clipPath id="clip0_219_27273">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowUpIcon;
